import { useCallback } from 'react'
import { useForm } from 'react-hook-form'

import useMutateSettings from '@/hooks/useMutateSettings'
import useScrollToError from '@/hooks/useScrollToError'

import { schema, type FormSchema } from './schema'
import { sanitizeMethodData } from './utils'
import formResolver from './validation'

export const useMethodForm = (method: FormSchema) => {
  const sanitizedMethod = sanitizeMethodData(method)

  const form = useForm<FormSchema>({
    defaultValues: schema.parse(sanitizedMethod),
    resolver: formResolver(schema),
    mode: 'onChange',
    shouldFocusError: true,
  })

  const mutation = useMutateSettings()
  const [setCanFocus] = useScrollToError(form.formState.errors)

  const submit = useCallback(
    async (data: FormSchema) => {
      try {
        await mutation.mutateAsync({
          methods: [{ ...data }],
        })
        form.reset(data)
        shopify.toast.show('Method updated', { duration: 2000 })
      } catch {
        setCanFocus(true)
      }
      return true
    },
    [mutation, form, setCanFocus]
  )

  return {
    form,
    submit,
    isPending: mutation.isPending,
  }
}
